import React from 'react'
import { Skeleton } from 'primereact/skeleton'

const EmrHistoryCardRowSkeleton = ({ count = 3, showActions = true }) => {
    return (
        <div className="mt-4">
            {Array.from({ length: count }).map((_, i) => (
                <div
                    key={i}
                    className='mb-6 border border-gray-200 rounded-lg overflow-hidden bg-white relative pl-0.5'
                >
                    <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-slate-100"></div>

                    <div className='bg-slate-50/80 px-5 py-4 border-b border-gray-200 flex flex-wrap items-start justify-between gap-6'>
                        <div className='flex flex-wrap items-start gap-x-12 gap-y-4 flex-1'>
                            <div className='space-y-2'>
                                <Skeleton width='3rem' height='0.5rem' />
                                <Skeleton width='9rem' height='1.2rem' />
                            </div>
                            <div className='space-y-2'>
                                <Skeleton width='4rem' height='0.5rem' />
                                <Skeleton width='10rem' height='1rem' />
                            </div>
                            <div className='hidden sm:block space-y-2'>
                                <Skeleton width='4rem' height='0.5rem' />
                                <Skeleton width='8rem' height='1rem' />
                            </div>
                            <div className='flex gap-10 items-start pt-0'>
                                <div className='space-y-2'>
                                    <Skeleton width='2rem' height='0.5rem' />
                                    <Skeleton width='4rem' height='1rem' />
                                </div>
                                <div className='space-y-2'>
                                    <Skeleton width='2rem' height='0.5rem' />
                                    <Skeleton width='4rem' height='1rem' />
                                </div>
                            </div>
                        </div>
                        {showActions && (
                            <div className='flex items-center gap-1 opacity-20'>
                                <Skeleton shape='circle' size='1.8rem' />
                                <Skeleton shape='circle' size='1.8rem' />
                            </div>
                        )}
                    </div>

                    <div className='p-6 space-y-8'>
                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-8'>
                            {Array.from({ length: 3 }).map((_, j) => (
                                <div key={j} className='space-y-2'>
                                    <Skeleton width='6rem' height='0.5rem' />
                                    <Skeleton width='95%' height='1rem' />
                                    <Skeleton width='70%' height='1rem' />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default EmrHistoryCardRowSkeleton
